import React, { useEffect } from 'react';
import { Grid, TextField } from '@material-ui/core';
import CheatDetectionConfig from './CheatDetectionConfig';

const ExamMetaForm = ({
  examTitle,
  setExamTitle,
  examCode,
  setExamCode,
  examTimer,
  setExamTimer,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  cheatDetectionSettings,
  setCheatDetectionSettings,
  validationErrors = {},
  hasInteracted = false,
  isCheckingDuplicate = false,
  examCodeExists = false
}) => {

  
  return (
  <Grid container spacing={2} style={{ marginBottom: 24 }}>

    <Grid item xs={12} sm={6} md={4}>
      <TextField
        label="Assessment Title"
        value={examTitle}
        onChange={e => setExamTitle(e.target.value)}
        variant="outlined"
        fullWidth
        required
        error={!!validationErrors.examTitle}
        helperText={validationErrors.examTitle || ''}

      />
    </Grid>
    <Grid item xs={12} sm={6} md={4}>
      <TextField
        label="Assessment Code"
        value={examCode}
        onChange={e => setExamCode(e.target.value)}
        variant="outlined"
        fullWidth
        required
        error={!!validationErrors.examCode}
        helperText={
          isCheckingDuplicate 
            ? 'Verifying availability...' 
            : validationErrors.examCode || 
              (examCodeExists && examCode.trim().length >= 3 ? 'This assessment code already exists' : '')
        }
        InputProps={{
          endAdornment: isCheckingDuplicate ? (
            <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}>
              <div style={{ width: 16, height: 16, border: '2px solid #ccc', borderTop: '2px solid #1976d2', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
            </div>
          ) : examCodeExists && examCode.trim().length >= 3 ? (
            <div style={{ color: '#f44336', marginRight: 8 }}>⚠️</div>
          ) : examCode.trim().length >= 3 && !examCodeExists ? (
            <div style={{ color: '#4caf50', marginRight: 8 }}>✓</div>
          ) : null
        }}
      />
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </Grid>
    <Grid item xs={12} sm={6} md={2}>
      <TextField
        label="Duration (minutes)"
        type="number"
        value={examTimer}
        onChange={e => setExamTimer(e.target.value)}
        variant="outlined"
        fullWidth
        required
        error={!!validationErrors.examTimer}
        helperText={validationErrors.examTimer ? validationErrors.examTimer : ''}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        label="Start Date & Time"
        type="datetime-local"
        value={startDate}
        onChange={e => setStartDate(e.target.value)}
        variant="outlined"
        fullWidth
        InputLabelProps={{ shrink: true }}
        required
        error={!!validationErrors.startDate}
        helperText={validationErrors.startDate ? validationErrors.startDate : "All times are in IST (Indian Standard Time)"}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        label="End Date & Time"
        type="datetime-local"
        value={endDate}
        onChange={e => setEndDate(e.target.value)}
        variant="outlined"
        fullWidth
        InputLabelProps={{ shrink: true }}
        required
        error={!!validationErrors.endDate}
        helperText={validationErrors.endDate ? validationErrors.endDate : "All times are in IST (Indian Standard Time)"}
      />
    </Grid>
    
    {/* Cheat Detection Configuration */}
    <Grid item xs={12}>
      <CheatDetectionConfig
        cheatDetectionSettings={cheatDetectionSettings}
        setCheatDetectionSettings={setCheatDetectionSettings}
        validationErrors={validationErrors}
      />
    </Grid>
  </Grid>
  );
};

export default ExamMetaForm; 